var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchQuery.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "设备编号" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入设备编号" },
                            model: {
                              value: _vm.queryParam.serialNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "serialNo", $$v)
                              },
                              expression: "queryParam.serialNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  [
                    _c(
                      "a-col",
                      { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "安装位置" } },
                          [
                            _c("a-input", {
                              attrs: { placeholder: "请输入安装位置" },
                              model: {
                                value: _vm.queryParam.cameraName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParam, "cameraName", $$v)
                                },
                                expression: "queryParam.cameraName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset },
                          },
                          [_vm._v("\n              重置\n            ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("新增")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function ($event) {
                  return _vm.handleExportXls("相机表")
                },
              },
            },
            [_vm._v("导出")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "import" },
              on: { click: _vm.ImportCamera },
            },
            [_vm._v("导入相机信息")]
          ),
          _vm.selectedRowKeys.length > 0
            ? _c(
                "a-dropdown",
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        { key: "1", on: { click: _vm.batchDel } },
                        [
                          _c("a-icon", { attrs: { type: "delete" } }),
                          _vm._v("\n          删除\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "8px" } },
                    [
                      _vm._v("\n        批量操作\n        "),
                      _c("a-icon", { attrs: { type: "down" } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" },
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon",
              }),
              _vm._v("\n      已选择\n      "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length)),
              ]),
              _vm._v("\n      项\n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected },
                },
                [_vm._v("清空")]
              ),
            ]
          ),
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange,
              },
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(record)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("gdCamera-modal", { ref: "modalForm", on: { ok: _vm.modalFormOk } }),
      _c("ImportCameraInfo", { ref: "importCameraInfoRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }